import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormFieldAbstractComponent } from '../field-abstract/form-field.abstract.component';
import { FormFieldModel } from '../field-abstract/form-field.model';
@Component({
    selector: 'form-mui-field',
    templateUrl: 'form-mui-field.html',
    styleUrls: ['../field-abstract/field.scss', 'form-mui-field.scss'],
    providers: [FormFieldModel],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormMuiFieldComponent extends FormFieldAbstractComponent {}
